module.exports = __webpack_public_path__ + "img/75756.92b62d25.svg";